import { screenshot } from './screenshot.js';
import * as video from './video.js';
const tools = {};
tools.screenshot = screenshot;

export { tools };
